import { watch } from "vue";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

export default () => {
  const watchWalletTagFieldByBlockchain = (
    showWalletTagByBlockchain,
    store
  ) => {
    const orderStore = useOrderFormStore();
    watch(
      () => showWalletTagByBlockchain.value,
      (showWalletTag) => {
        // to remove from the payload on submit
        if (showWalletTag && showWalletTag?.required) {
          store.setRequiredFieldByKey("walletAddressTag", true);
        } else if (
          !orderStore.getActiveStore?.form?.walletAddressTag?.fromApi
        ) {
          store.setRequiredFieldByKey("walletAddressTag", false);
        }
      },
      { deep: true }
    );
  };

  return {
    watchWalletTagFieldByBlockchain,
  };
};
